import { useModalClose } from "lib/analytics/react/modal";
import { RefObject, useEffect, useRef } from "react";

const useModalClickOutside = (setModal: (value: boolean) => void, notClickable = false) => {

    const modalRef = useRef<HTMLDivElement>(null);
    const { trackClose, modalId } = useModalClose();

    // 모달 외부 클릭을 감지하는 이벤트 핸들러
    const handleClickOutside = (event: MouseEvent) => {
        if (notClickable) return;
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
            console.log("modalId", modalId);
            setModal(false);
            // modalId가 null이면 Provider 외부에서 사용 중 (tracking 안됨)
            // modalId가 있으면 Provider 내부에서 사용 중 (tracking 활성화)
            if (modalId) {
                trackClose("backdrop");
            }
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    return modalRef as React.LegacyRef<HTMLImageElement | HTMLDivElement> | undefined;
}

export default useModalClickOutside;